import { isOnPage } from './utils';

/**
 * Dropdowns
 */
const initDropdowns = () => {
  const state = { activeDropdown: 0 };
  const dropdowns = Array.from(document.querySelectorAll('.form__dropdown'));
  const dropdownLists = Array.from(document.querySelectorAll('.form__dropdown ul'));

  const render = () => {
    dropdownLists.forEach((el) => el.classList.remove('active'));
    dropdownLists[state.activeDropdown].classList.add('active');
  };

  dropdowns.forEach((dropdown, index) => {
    const button = dropdown.querySelector('button');
    const list = dropdown.querySelector('ul');
    const toggleAll = dropdown.querySelector('input[data-toggle-all]');
    const inputs = Array.from(list.querySelectorAll('input'));
    const buttonDefaultText = button.dataset.defaultText;
    const [titleSingular, titleLessThenTen, titleMultiple] = dropdown.dataset.title.split(',');
    const [buttonTextSingular, buttonTextMultiple] = button.dataset.text.split(',');

    button.addEventListener('click', (e) => {
      e.stopPropagation();
      if (index === state.activeDropdown) {
        list.classList.toggle('active');
      } else {
        state.activeDropdown = index;
        render();
      }
    });
    list.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    if (toggleAll !== null) {
      toggleAll.addEventListener('change', (e) => {
        e.stopPropagation();
        if (e.target.checked) {
          inputs.forEach((input) => {
            input.checked = false;
          });
        }
      });
    }

    const inputCallback = () => {
      const customBtnText = [];
      let count = 0;
      let title = '';
      let btnText = '';
      let isCustomLabelSet = false;

      inputs.forEach((i) => {
        if (i.checked) {
          count += 1;
        }

        if (i.hasAttribute('data-label') && i.checked) {
          isCustomLabelSet = true;
          customBtnText.push(i.dataset.label);
        }
      });

      if (isCustomLabelSet) {
        button.querySelector('.btn__text').textContent = customBtnText.join(' и ');

        return;
      }

      if (toggleAll !== null) {
        count -= (toggleAll.checked) ? 1 : 0;
        toggleAll.checked = (count === 0);
      }

      switch (count) {
        case 1:
          title = titleSingular;
          btnText = buttonTextSingular;
          break;
        case 2:
        case 3:
        case 4:
          title = titleLessThenTen;
          btnText = buttonTextMultiple;
          break;
        default:
          title = titleMultiple;
          btnText = buttonTextMultiple;
          break;
      }

      button.querySelector('.btn__text').textContent = (count > 0) ? `${btnText} ${count} ${title}` : buttonDefaultText;
    };

    inputs.forEach((input) => {
      input.addEventListener('change', inputCallback);
    });

    window.addEventListener('load', () => {
      inputs.forEach((input) => {
        if (input.checked) {
          inputCallback();
        }
      });
    });
  });

  window.addEventListener('click', () => {
    dropdownLists.forEach((el) => el.classList.remove('active'));
  });
};

if (isOnPage('.form__dropdown')) {
  initDropdowns();
}

/**
 * Districts
 */
const districtsEndpoint = `${window.location.origin}/wp-json/motion/v1/districts`;
const initDistricts = () => {
  const state = {
    pending: false,
    districtsHtml: null,
    areas: [],
  };
  const areasContainer = document.getElementById('search-area-input');
  const inputs = Array.from(areasContainer.querySelectorAll('input'));
  const districtsContainer = document.querySelector('#search-district-input .form__dropdown-list');
  const ajaxLoader = document.querySelector('#search-district-input .ajax-loader');

  const render = (s) => {
    if (s.pending) {
      ajaxLoader.classList.add('ajax-loader--visible');
    } else {
      ajaxLoader.classList.remove('ajax-loader--visible');
    }

    districtsContainer.innerHTML = s.districtsHtml;
  };

  const getDistricts = () => {
    $.ajax({
      url: districtsEndpoint,
      data: {
        areas: state.areas,
      },
      beforeSend() {
        state.pending = true;
        state.districtsHtml = null;
        render(state);
      },
      success(data) {
        state.districtsHtml = data;
      },
      complete() {
        state.pending = false;
        render(state);
      },
    });
  };

  const checkInputs = (inputElements) => {
    inputElements.forEach((input) => {
      if (input.checked && !state.areas.includes(input.value)) {
        state.areas.push(input.value);
      } else if (!input.checked) {
        state.areas = state.areas.filter((area) => area !== input.value);
      }
    });

    getDistricts();
  };

  inputs.forEach((input) => {
    input.addEventListener('change', (e) => {
      checkInputs(inputs);
    });
  });

  window.addEventListener('load', (e) => {
    checkInputs(inputs);
  });
};

if (isOnPage('#search-area-input')) {
  initDistricts();
}

/**
 * Search results order
 */
const initResultsOrder = () => {
  const searchForm = document.querySelector('#search-form');
  const orderInput = document.querySelector('#order');
  const availableInput = document.querySelector('#available');

  orderInput.addEventListener('change', () => {
    searchForm.submit();
  });
  availableInput.addEventListener('change', () => {
    searchForm.submit();
  });
};

if (isOnPage('#order-form')) {
  initResultsOrder();
}
